// Provider mapping from old keys to the provider provider keys
export const PROVIDER_MAP: Record<string, string> = {
  gmail: "google-mail",
  outlook: "outlook-oauth",
  slack: "slack-oauth",
};

// Action-specific success messages for toast notifications
export const ACTION_SUCCESS_MESSAGES: Record<string, string> = {
  delete: "Message deleted successfully",
  archive: "Message archived successfully",
  mark_as_read: "Message marked as read",
  mark_as_unread: "Message marked as unread",
  reply: "Reply sent successfully",
  forward: "Message forwarded successfully",
};

// Actions that modify message state and require query invalidation
export const STATE_MODIFYING_ACTIONS = ["mark_as_read", "mark_as_unread", "delete", "archive"];
